// extracted by mini-css-extract-plugin
module.exports =  {"root":"TrZY33RjbMuG9RRJ2vTu","item":"qH01q8uaBBZZ_PyUm1Ke","label":"E9zfREURCDbOhwWSDA4U"};